export function getBetsInfo() {
    const betsInfo=[
        {name: 'Baloto', result: [null, null, null, null, null], superResult: true, serial: true},
        {name: 'Baloto Revancha', result: [null, null, null, null, null], superResult: true, serial: true},
        {name: 'MiLoto', result: [null, null, null, null, null], serial: true},
        {name: 'ColorLoto', result: [null, null, null, null, null, null], colors: [null, null, null, null, null, null], serial: true},
        {name: 'Super astro sol', result: null, zodiac: true, serial: true},
        {name: 'Super astro luna', result: null, zodiac: true, serial: true},
        {name: 'El dorado mañana', result: null},
        {name: 'El dorado tarde', result: null},
        {name: 'El dorado noche', result: null},
        {name: 'Chontico Millonario día', result: null},
        {name: 'Chontico Millonario noche', result: null},
        {name: 'Chontico Millonario noche jueves', result: null},
        {name: 'El paisita día', result: null},
        {name: 'El paisita noche', result: null},
        {name: 'El paisita 3', result: null},
        {name: 'Lotería de Boyacá', result: null, series: true, serial: true},
        {name: 'Lotería de la Cruz Roja', result: null, series: true, serial: true},
        {name: 'Lotería de Medellín', result: null, series: true, serial: true},
        {name: 'Lotería de Bogotá', result: null, series: true, serial: true},
        {name: 'Lotería del Valle', result: null, series: true, serial: true},
        {name: 'Lotería de Manizales', result: null, series: true, serial: true},
        {name: 'Lotería del Tolima', result: null, series: true, serial: true},
        {name: 'Lotería de Cundinamarca', result: null, series: true, serial: true},
    ];
    return betsInfo;
};

export function getBetsValuesAllowed() {
    const betsValuesAllowed=[
        {name: 'Baloto', result: [1,43], superResult: [1,16], weekDays: [1,3,6]},
        {name: 'Baloto Revancha', result: [1,43], superResult: [1,16], weekDays: [1,3,6]},
        {name: 'MiLoto', result: [1,39], weekDays: [1,2,4,5]},
        {name: 'ColorLoto', result: [1,7], color: ['yellow','blue','red','green','white','black'], weekDays: [1,4]},
        {name: 'Super astro sol', result: [0,9999], zodiac: ['Acuario','Piscis','Aries','Tauro','Géminis','Cáncer','Leo','Virgo','Libra','Escorpio','Sagitario','Capricornio'], weekDays: [1,2,3,4,5,6]},
        {name: 'Súper astro luna', result: [0,9999], zodiac: ['Acuario','Piscis','Aries','Tauro','Géminis','Cáncer','Leo','Virgo','Libra','Escorpio','Sagitario','Capricornio']},
        {name: 'El dorado mañana', result: [0,9999], weekDays: [1,2,3,4,5,6]},
        {name: 'El dorado tarde', result: [0,9999], weekDays: [1,2,3,4,5,6]},
        {name: 'El dorado noche', result: [0,9999], weekDays: [0,6]},
        {name: 'Chontico Millonario día', result: [0,9999]},
        {name: 'Chontico Millonario noche', result: [0,9999]},
        {name: 'Chontico Millonario noche jueves', result: [0,9999]},
        {name: 'El paisita día', result: [0,9999]},
        {name: 'El paisita noche', result: [0,9999]},
        {name: 'El paisita 3', result: [0,9999], weekDays: [4]},
        {name: 'Lotería de Boyacá', result: [0,9999]},
        {name: 'Lotería de la Cruz Roja', result: [0,9999]},
        {name: 'Lotería de Medellín', result: [0,9999]},
        {name: 'Lotería de Bogotá', result: [0,9999]},
        {name: 'Lotería del Valle', result: [0,9999]},
        {name: 'Lotería de Manizales', result: [0,9999]},
        {name: 'Lotería del Tolima', result: [0,9999]},
        {name: 'Lotería de Cundinamarca', result: [0,9999]},
    ];
    return betsValuesAllowed;
};